import { styled } from '@mui/material/styles';
import { Button, Dialog } from '@mui/material';
import { COLOR } from '@src/styles/color';
import BlinkImg from '@src/assets/images/blink.png';

const StyledDialog = styled(Dialog)`
  .MuiPaper-root {
    border-radius: 16px;
  }
  .wrap-actions {
    padding: 12px 24px;
  }
  .wrap-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .wrap-content {
    padding: 12px 24px;
  }
  .title {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .text-title {
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px;
    letter-spacing: -0.4px;
    color: ${COLOR.darkGray};
  }
  .input {
    width: 100%;
  }
  .text-area-input {
    width: 100%;
    border-radius: 12px;
    font-size: 16px;
    box-sizing: border-box;
    resize: none;
    font-family: 'SF Pro Text', sans-serif;
    padding: 12px;
  }
`;

const StyledActionDialog = styled(Dialog)`
  min-width: ${(props) => props.width || 'auto'};

  .dialog-title {
    text-align: center;
  }

  .close-button {
    position: absolute;
    top: 8px;
    right: 8px;
  }

  .dialog-wrapper {
    padding: 10px 30px 23px 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .img-wrapper {
    display: flex;
    justify-content: center;
  }

  .img {
    width: 100px;
    height: 100px;
  }

  .title {
    font-size: 21px;
    margin-bottom: 10px;
    font-weight: 500;
    text-align: center;
  }

  .description {
    font-size: 14px;
    text-align: center;
  }

  .dialog-action {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
`;

const StyledNotificationSuccess = styled(Dialog)`
  min-width: ${(props) => props.width || 'auto'};

  .dialog-content {
    background-image: url(${BlinkImg});
    background-repeat: no-repeat, repeat;
  }

  .dialog-title {
    text-align: center;
  }

  .close-button {
    position: absolute;
    top: 8px;
    right: 8px;
  }

  .dialog-wrapper {
    padding: 10px 30px 23px 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .img-wrapper {
    display: flex;
    justify-content: center;
  }

  .img {
    // width: 185px;
    height: 145px;
  }

  .title {
    margin-bottom: 10px;
    margin-top: 20px;
    text-align: center;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
  }

  .description {
    text-align: center;
    font-size: 16px;
    line-height: 24px;
  }

  .dialog-action {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }

  .action-button {
    text-transform: normal;
  }

  .img-button {
    width: 26px;
    height: 26px;
  }
`;

const StyledSimpleDialog = styled(Dialog)`
  .title {
    display: flex;
    gap: 8px;
    align-items: center;
    margin-bottom: 8px;

    .title-text {
      font-weight: 700;
      font-size: 20px;
    }
  }

  .description {
    color: ${COLOR.dark};
    line-height: 20px;
  }
`;

const StyledNewConfirmDialog = styled(Dialog)`
  .MuiDialog-paper {
    max-width: 580px;
    border-radius: 16px;
  }

  .wrapper {
    display: flex;
    flex-direction: column;
    padding: 16px 32px 32px 32px;
    gap: 16px;
  }

  .title-content {
    font-size: 20px;
    font-weight: 700;
    line-height: 32px;
    color: ${COLOR.indigo[100]};
  }

  .content {
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: ${COLOR.black.default};
  }

  .action {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 8px;

    .action-button {
      text-transform: none;
      height: 40px;
      padding: 8px 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      line-height: 24px;
      font-weight: 500;
      letter-spacing: -0.4px;
      border-radius: 500px;
    }

    .single {
      display: flex;
      justify-content: center !important;
    }

    .left-button {
      border: 1px solid ${COLOR.indigo[32]};
      color: ${COLOR.indigo[100]};
      width: 100%;
    }

    .right-button {
      border: 1px solid ${COLOR.yellow.default};
      background-color: ${COLOR.yellow.default};
      color: ${COLOR.indigo[100]};
      width: 100%;
    }
  }
`;

const StyledButton = styled(Button)`
  &.Mui-disabled {
    background: ${(props) =>
      props.bgrDisble ? props.bgrDisble : COLOR.gray[32]};
    color: ${(props) =>
      props.colorDisable ? props.colorDisable : COLOR.gray[100]};
  }

  color: ${(props) =>
    props.colorText ? props.colorText : COLOR.indigo.default};
  border-color: ${(props) =>
    props.borderColor ? props.borderColor : COLOR.primary};
  height: 36px;
  border-radius: 500px;

  font-size: 14px;
  font-style: normal;
  text-transform: none;
  font-weight: 700;
  letter-spacing: -0.4px;
`;

export {
  StyledDialog,
  StyledActionDialog,
  StyledNotificationSuccess,
  StyledSimpleDialog,
  StyledNewConfirmDialog,
  StyledButton,
};
